// 會員成人模式切換按鈕
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import authClient from '@/common/apiClient/authClient';
import { userMutate, userState } from '@/slices/userSlice';
import { sendInteractMsgToOther } from '@/common/socketFunctions';

const UserToggleAdultButton = ({ location }) => {
    const dispatch = useDispatch();
    const { user = {} } = useSelector(userState);
    const { is18 = false } = user;
    const { t } = useTranslation();

    // 開關狀態
    const [lock, setLock] = useState(false);

    // 切換
    const onToggle = async () => {
        try {
            const { message } = await authClient.toggleAdultState();
            if (message === 'success') {
                dispatch(userMutate({ is18: !is18 }));
                setLock((prev) => !prev);

                // 發通知到其他裝置
                const payload = {
                    uid: user?.uid,
                    userChange: { is18: !is18 },
                };
                await sendInteractMsgToOther(payload);
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        setLock(!is18);
    }, [is18]);

    return (
        <div
            className={`flex items-center gap-x-[9px] w-full
        ${location === 'menu' ? '' : 'border-b-1 border-dashed border-black2 pb-[12px]'}`}
        >
            <span className="text-btn1 text-bou flex-shrink-0">{t('UNLOCK')}</span>

            <button
                onClick={onToggle}
                className={`w-[111px] rounded-[107px] trans relative flex-shrink-0 flex items-center [&>span]:z-[0] [&>span]:trans [&>span]:text-[#fff] [&>span]:absolute
                px-[3px] py-[3px] ${!lock ? 'bg-bou' : 'bg-black5'} text-btn1`}
            >
                <span className={`left-[12px] ${!lock ? '' : 'opacity-0'}`}>{t('ADULT')}</span>

                <span className={`right-[12px] ${lock ? '' : 'opacity-0'}`}>{t('ADULT')}</span>

                <i
                    className={`trans w-[28px] h-[28px] rounded-[50%] bg-[#fff] shadow-[0px_0px_4px_0px_rgba(80,80,80,0.71)] inline-block
                ${!lock ? 'translate-x-[77px]' : ''}`}
                />
            </button>
        </div>
    );
};

export default UserToggleAdultButton;
